import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const notify = (message, type = 'success') => {

    const options = {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    };

    let toastMessage = message;

    if(typeof message === 'object') {
        toastMessage = '';
        for (const [key, value] of Object.entries(message)) {
            if(Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    toastMessage += `${capitalizeFirstLetter(value[i])} `;    
                }
            } else if(typeof value === 'string') {
                toastMessage += `${capitalizeFirstLetter(value)} `;
            }
        }
    }

    if(toastMessage) {
        switch (type) {
            case 'success':
                toast.success(toastMessage, options);
                break;
            case 'info':
                toast.info(toastMessage, options);
                break;
            case 'error':
                toast.error(toastMessage, options);
                break;
            default:
                break;
        }
    }
};

export default notify;
